import { Slide, SlideComponentProps } from '../../Slide';
import { Accordion } from '../components/Accordion';
import { AncestryAmerican } from './AncestryAccordionItems/AncestryAmerican';
import AncestryAsian from './AncestryAccordionItems/AncestryAsian';
import AncestryBlack from './AncestryAccordionItems/AncestryBlack';
import AncestryHawaiian from './AncestryAccordionItems/AncestryHawaiian';
import AncestryHispanic from './AncestryAccordionItems/AncestryHispanic';
import AncestryWhite from './AncestryAccordionItems/AncestryWhite';

type AncestryProps = SlideComponentProps;

export const Ancestry = ({ slide, ...rest }: AncestryProps) => {
  return (
    <Slide slide={slide} {...rest}>
      <Accordion>
        <AncestryWhite />
        <AncestryAsian />
        <AncestryBlack />
        <AncestryAmerican />
        <AncestryHawaiian />
        <AncestryHispanic />
      </Accordion>
    </Slide>
  );
};
